var map = {
	"./AGILITY.png": 219,
	"./AGILITY_COLOUR.png": 220,
	"./ASTROAI-text.png": 221,
	"./AUDIO ICON.png": 117,
	"./ArrowLeft-blue.png": 222,
	"./ArrowLeft-green.png": 223,
	"./ArrowLeft-orange.png": 224,
	"./ArrowLeft-pink.png": 225,
	"./ArrowRight-blue.png": 226,
	"./ArrowRight-green.png": 227,
	"./ArrowRight-orange.png": 228,
	"./ArrowRight-pink.png": 229,
	"./BALANCE.png": 230,
	"./BALANCE_COLOUR.png": 231,
	"./COMBAT.png": 232,
	"./COMBAT_COLOUR.png": 233,
	"./DANCE.png": 234,
	"./DANCE_COLOUR.png": 235,
	"./Lock-icon.png": 236,
	"./POWER.png": 237,
	"./POWER_COLOUR.png": 238,
	"./Puma_Female_Left_low.jpg": 100,
	"./Puma_Female_Right_low.jpg": 101,
	"./STRENGTH.png": 239,
	"./STRENGTH_COLOUR.png": 240,
	"./Shoe_BlueRedInside.png": 119,
	"./Shoe_LimePinkInside.png": 120,
	"./Sneaker_Male_Left_low.jpg": 102,
	"./Sneaker_Male_Right_low.jpg": 103,
	"./Social-share-image.png": 121,
	"./Standing-man.svg": 241,
	"./Stretching-man.svg": 242,
	"./add-sign-reverse.png": 122,
	"./add-sign.png": 43,
	"./arrow_right.png": 67,
	"./arrow_up.png": 68,
	"./astro-ByPuma.png": 65,
	"./by-puma-logo.png": 243,
	"./cross-icon-reverse.png": 74,
	"./cross-icon.png": 53,
	"./cross-reverse.png": 123,
	"./cross.png": 124,
	"./evolution-icon.png": 125,
	"./exercise-not-recognized.png": 104,
	"./follow-astro.png": 105,
	"./line-up-astro.png": 69,
	"./main-bg.jpg": 244,
	"./melbourne-logo.png": 245,
	"./nav-puma-logo.png": 126,
	"./next-exercise.png": 106,
	"./pause-icon.png": 246,
	"./play-btn.png": 247,
	"./play-level-reverse.png": 127,
	"./play-level.png": 128,
	"./puma-coming.png": 248,
	"./puma-logo.png": 66,
	"./puma-logo2.png": 249,
	"./remove-icon-reverse.png": 129,
	"./remove-icon.png": 130,
	"./session-complete.png": 107,
	"./thank-you.png": 108,
	"./tick.svg": 109,
	"./train-icon.png": 131,
	"./training-successful.png": 110,
	"./video-photo.png": 250,
	"./warm-up-complete.png": 111,
	"./watch-icon.png": 132
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 118;